/* eslint-disable */
import Handlebars from 'handlebars';

Handlebars.registerHelper('productImageUrl', function (product) {
    try {
        return product.images[0].url;
    } catch {
        return '/_ui/responsive/common/images/missing-product.png';
    }
});
